'use strict';
define('codes',[], function () {
	return {
		'dice.combinations.atleast_one_pair': 200,
		'dice.combinations.any_two_pairs': 201,
		'dice.combinations.three_any_kind': 202,
		'dice.combinations.sequence_1_5': 203,
		'dice.combinations.sequence_2_6': 204,
		'dice.combinations.all_different': 205,
		'dice.combinations.any_one_pair_any_triple': 206,
		'dice.combinations.four_of_a_kind': 207,
		'dice.combinations.five_of_a_kind': 208,
		'dice.numbers.exactly_two': 209,
		'dice.numbers.exactly_three': 211,
		'dice.numbers.chosen_drop': 212,
		'dice.numbers.chosen_no_drop': 213,
		'dice.sum.less_17_5': 214,
		'dice.sum.more_17_5': 215,
		'dice.sum.less_13_5': 216,
		'dice.sum.more_13_5': 217,
		'dice.sum.less_21_5': 218,
		'dice.sum.more_21_5': 219,
		'dice.sum.less_10_5': 220,
		'dice.sum.more_10_5': 221,
		'dice.sum.less_24_5': 222,
		'dice.sum.more_24_5': 223,
		'dice.oddeven.more_odd': 224,
		'dice.oddeven.more_even': 225,
		'dice.oddeven.four_odd_one_even': 226,
		'dice.oddeven.four_even_one_odd': 227,
		'dice.oddeven.all_even': 228,
		'dice.oddeven.all_odd': 229,
		// Dice duel codes
		// https://bitbucket.org/advbet/core-backend/src/dev/modules/betgames/diceDuel/betoption.go
		'diceDuel.main.red_wins': 250,
		'diceDuel.main.draw': 251,
		'diceDuel.main.blue_wins': 252,
		'diceDuel.numbers.chosen_red_roll': 253,
		'diceDuel.numbers.chosen_blue_roll': 254,
		'diceDuel.numbers.chosen_red_blue_combination': 255,
		'diceDuel.oddeven.red_odd': 256,
		'diceDuel.oddeven.red_even': 257,
		'diceDuel.oddeven.blue_odd': 258,
		'diceDuel.oddeven.blue_even': 259,
		'diceDuel.oddeven.sum_odd': 260,
		'diceDuel.oddeven.sum_even': 261,
		'diceDuel.totals.red_pips_less_than_3_5': 262,
		'diceDuel.totals.red_pips_more_than_3_5': 263,
		'diceDuel.totals.blue_pips_less_than_3_5': 264,
		'diceDuel.totals.blue_pips_more_than_3_5': 265,
		'diceDuel.totals.sum_less_than_4_5': 266,
		'diceDuel.totals.sum_more_than_4_5': 267,
		'diceDuel.totals.sum_less_than_5_5': 268,
		'diceDuel.totals.sum_more_than_5_5': 269,
		'diceDuel.totals.sum_less_than_6_5': 270,
		'diceDuel.totals.sum_more_than_6_5': 271,
		'diceDuel.totals.sum_less_than_7_5': 272,
		'diceDuel.totals.sum_more_than_7_5': 273,
		'diceDuel.totals.sum_less_than_8_5': 274,
		'diceDuel.totals.sum_more_than_8_5': 275,
		'diceDuel.totals.sum_less_than_9_5': 276,
		'diceDuel.totals.sum_more_than_9_5': 277,
		'lucky7.numbers.zero_one_drop': 700,
		'lucky7.numbers.one_drop': 701,
		'lucky7.numbers.two_drop': 702,
		'lucky7.numbers.three_drop': 703,
		'lucky7.numbers.four_drop': 704,
		'lucky7.numbers.zero_seven_drop': 770,
		'lucky7.numbers.one_seven_drop': 771,
		'lucky7.numbers.two_seven_drop': 772,
		'lucky7.numbers.three_seven_drop': 773,
		'lucky7.numbers.four_seven_drop': 774,
		'lucky7.numbers.five_seven_drop': 775,
		'lucky7.balls.yellow_less_73_5': 749,
		'lucky7.balls.yellow_more_73_5': 750,
		'lucky7.balls.black_less_73_5': 758,
		'lucky7.balls.black_more_73_5': 759,
		'lucky7.sum.less_100_5': 705,
		'lucky7.sum.less_125_5': 706,
		'lucky7.sum.more_125_5': 707,
		'lucky7.sum.less_150_5': 730,
		'lucky7.sum.more_150_5': 745,
		'lucky7.sum.less_175_5': 746,
		'lucky7.sum.more_175_5': 747,
		'lucky7.sum.more_200_5': 748,
		'lucky7.count.yellow_less_3_5': 731,
		'lucky7.count.yellow_more_3_5': 732,
		'lucky7.count.yellow_less_2_5': 733,
		'lucky7.count.yellow_more_2_5': 734,
		'lucky7.count.yellow_less_1_5': 735,
		'lucky7.count.yellow_more_1_5': 736,
		'lucky7.count.yellow_no_drop': 737,
		'lucky7.count.yellow_one_drop': 751,
		'lucky7.count.yellow_two_drop': 752,
		'lucky7.count.yellow_three_drop': 753,
		'lucky7.count.yellow_four_drop': 754,
		'lucky7.count.yellow_five_drop': 755,
		'lucky7.count.yellow_six_drop': 756,
		'lucky7.count.yellow_seven_drop': 757,
		'lucky7.count.black_less_3_5': 738,
		'lucky7.count.black_more_3_5': 739,
		'lucky7.count.black_less_2_5': 740,
		'lucky7.count.black_more_2_5': 741,
		'lucky7.count.black_less_1_5': 742,
		'lucky7.count.black_more_1_5': 743,
		'lucky7.count.black_no_drop': 744,
		'lucky7.count.black_one_drop': 761,
		'lucky7.count.black_two_drop': 762,
		'lucky7.count.black_three_drop': 763,
		'lucky7.count.black_four_drop': 764,
		'lucky7.count.black_five_drop': 765,
		'lucky7.count.black_six_drop': 766,
		'lucky7.count.black_seven_drop': 767,
		'lucky7.oddeven.more_odd': 708,
		'lucky7.oddeven.more_even': 709,
		'lucky7.oddeven.sum_odd': 710,
		'lucky7.oddeven.sum_even': 711,
		'lucky7.oddeven.first_odd': 712,
		'lucky7.oddeven.first_even': 713,
		'lucky7.oddeven.last_odd': 714,
		'lucky7.oddeven.last_even': 715,
		'lucky7.oddeven.first_two_odd': 716,
		'lucky7.oddeven.first_two_even': 717,
		'lucky7.oddeven.first_odd_second_even': 718,
		'lucky7.oddeven.first_even_second_odd': 719,
		'lucky7.oddeven.first_odd_last_even': 720,
		'lucky7.oddeven.first_even_last_odd': 721,
		'lucky7.color.first_yellow': 722,
		'lucky7.color.first_black': 723,
		'lucky7.color.last_yellow': 724,
		'lucky7.color.last_black': 725,
		'lucky7.color.more_yellow': 726,
		'lucky7.color.more_black': 727,
		'lucky7.color.first_same_second': 728,
		'lucky7.color.first_different_second': 729,
		'lucky5.numbers.zero_one_drop': 500,
		'lucky5.numbers.one_drop': 501,
		'lucky5.numbers.two_drop': 502,
		'lucky5.numbers.three_drop': 503,
		'lucky5.numbers.more_odd': 506,
		'lucky5.numbers.more_even': 507,
		'lucky5.numbers.sum_odd': 508,
		'lucky5.numbers.sum_even': 509,
		'lucky5.numbers.less_92_5': 510,
		'lucky5.numbers.more_92_5': 511,
		'lucky5.white.atleast_one': 512,
		'lucky5.white.one_drop': 548,
		'lucky5.white.two_drop': 550,
		'lucky5.white.three_drop': 552,
		'lucky5.white.four_drop': 554,
		'lucky5.white.five_drop': 520,
		'lucky5.white.no_drop': 513,
		'lucky5.white.one_no_drop': 549,
		'lucky5.white.two_no_drop': 551,
		'lucky5.white.three_no_drop': 553,
		'lucky5.white.count_more_1_5': 514,
		'lucky5.white.count_less_1_5': 515,
		'lucky5.white.count_more_2_5': 516,
		'lucky5.white.count_less_2_5': 517,
		'lucky5.white.count_more_3_5': 518,
		'lucky5.green.atleast_one': 521,
		'lucky5.green.one_drop': 557,
		'lucky5.green.two_drop': 559,
		'lucky5.green.three_drop': 561,
		'lucky5.green.four_drop': 563,
		'lucky5.green.five_drop': 529,
		'lucky5.green.no_drop': 522,
		'lucky5.green.one_no_drop': 558,
		'lucky5.green.two_no_drop': 560,
		'lucky5.green.three_no_drop': 562,
		'lucky5.green.count_more_1_5': 523,
		'lucky5.green.count_less_1_5': 524,
		'lucky5.green.count_more_2_5': 525,
		'lucky5.green.count_less_2_5': 526,
		'lucky5.green.count_more_3_5': 527,
		'lucky5.red.atleast_one': 530,
		'lucky5.red.one_drop': 566,
		'lucky5.red.two_drop': 568,
		'lucky5.red.three_drop': 570,
		'lucky5.red.four_drop': 572,
		'lucky5.red.five_drop': 538,
		'lucky5.red.no_drop': 531,
		'lucky5.red.one_no_drop': 567,
		'lucky5.red.two_no_drop': 569,
		'lucky5.red.three_no_drop': 571,
		'lucky5.red.count_more_1_5': 532,
		'lucky5.red.count_less_1_5': 533,
		'lucky5.red.count_more_2_5': 534,
		'lucky5.red.count_less_2_5': 535,
		'lucky5.red.count_more_3_5': 536,
		'lucky5.blue.atleast_one': 539,
		'lucky5.blue.one_drop': 575,
		'lucky5.blue.two_drop': 577,
		'lucky5.blue.three_drop': 579,
		'lucky5.blue.four_drop': 581,
		'lucky5.blue.five_drop': 547,
		'lucky5.blue.no_drop': 540,
		'lucky5.blue.one_no_drop': 576,
		'lucky5.blue.two_no_drop': 578,
		'lucky5.blue.three_no_drop': 580,
		'lucky5.blue.count_more_1_5': 541,
		'lucky5.blue.count_less_1_5': 542,
		'lucky5.blue.count_more_2_5': 543,
		'lucky5.blue.count_less_2_5': 544,
		'lucky5.blue.count_more_3_5': 545,
		'lucky5.color.atleast_three_same_color': 584,
		'lucky5.color.atleast_four_same_color': 586,
		'lucky5.color.five_same_drop': 588,
		'lucky5.color.white_green_more_than_red_blue': 590,
		'lucky5.color.white_red_more_than_green_blue': 591,
		'lucky5.color.white_blue_more_than_green_red': 592,
		'lucky5.color.white_more_than_green': 593,
		'lucky5.color.green_more_than_white': 594,
		'lucky5.color.white_equal_green': 595,
		'lucky5.color.white_more_than_red': 596,
		'lucky5.color.red_more_than_white': 597,
		'lucky5.color.white_equal_red': 598,
		'lucky5.color.white_more_than_blue': 599,
		'lucky5.color.blue_more_than_white': 528,
		'lucky5.color.white_equal_blue': 504,
		'lucky5.color.green_more_than_red': 505,
		'lucky5.color.red_more_than_green': 519,
		'lucky5.color.green_equal_red': 537,
		'lucky5.color.green_more_than_blue': 546,
		'lucky5.color.blue_more_than_green': 555,
		'lucky5.color.green_equal_blue': 556,
		'lucky5.color.red_more_than_blue': 564,
		'lucky5.color.blue_more_than_red': 565,
		'lucky5.color.red_equal_blue': 573,
		'wheel.numbers.selected': 401,
		'wheel.numbers.range_1_6': 402,
		'wheel.numbers.range_7_12': 403,
		'wheel.numbers.range_13_18': 404,
		'wheel.numbers.less_9_5': 405,
		'wheel.numbers.more_9_5': 406,
		'wheel.color.black': 413,
		'wheel.color.fortune': 414,
		'wheel.color.diamond': 414,
		'wheel.color.grey': 411,
		'wheel.color.green': 411,
		'wheel.color.red': 412,
		'wheel.color.orange': 412,
		'wheel.oddeven.even': 421,
		'wheel.oddeven.odd': 422,
		'wheel.oddeven.grey_even': 423,
		'wheel.oddeven.grey_odd': 424,
		'wheel.oddeven.green_odd': 424,
		'wheel.oddeven.green_even': 423,
		'wheel.oddeven.red_even': 425,
		'wheel.oddeven.red_odd': 426,
		'wheel.oddeven.orange_even': 425,
		'wheel.oddeven.orange_odd': 426,
		'wheel.oddeven.black_even': 427,
		'wheel.oddeven.black_odd': 428,
		'lucky6.color.blue_sum_less_12_5': 112,
		'lucky6.color.blue_sum_more_12_5': 113,
		'lucky6.color.red_sum_less_13_5': 110,
		'lucky6.color.red_sum_more_13_5': 111,
		'lucky6.color.zone_a_sum_less_9_5': 114,
		'lucky6.color.zone_a_sum_more_9_5': 115,
		'lucky6.color.zone_b_sum_less_9_5': 116,
		'lucky6.color.zone_b_sum_more_9_5': 117,
		'lucky6.color.zone_c_sum_less_9_5': 118,
		'lucky6.color.zone_c_sum_more_9_5': 119,
		'lucky6.count.number_even': 108,
		'lucky6.count.number_less_1_5': 107,
		'lucky6.count.number_more_1_5': 106,
		'lucky6.count.number_odd': 109,
		'lucky6.numbers.one_drop_zone_a': 100,
		'lucky6.numbers.one_drop_zone_b': 101,
		'lucky6.numbers.one_drop_zone_c': 102,
		'lucky6.numbers.two_drop_zone_a': 103,
		'lucky6.numbers.two_drop_zone_b': 104,
		'lucky6.numbers.two_drop_zone_c': 105,
		'lucky6.oddeven.count_even_less_2_5': 122,
		'lucky6.oddeven.count_even_more_2_5': 123,
		'lucky6.oddeven.count_odd_less_2_5': 124,
		'lucky6.oddeven.count_odd_more_2_5': 125,
		'lucky6.oddeven.sum_even': 120,
		'lucky6.oddeven.sum_odd': 121,
		'lucky6.oddeven.sum_zone_a_even': 126,
		'lucky6.oddeven.sum_zone_a_odd': 127,
		'lucky6.oddeven.sum_zone_b_even': 128,
		'lucky6.oddeven.sum_zone_b_odd': 129,
		'lucky6.oddeven.sum_zone_c_even': 130,
		'lucky6.oddeven.sum_zone_c_odd': 131,
		'lucky6.sum.less_15_5': 134,
		'lucky6.sum.less_26_5': 132,
		'lucky6.sum.less_38_5': 136,
		'lucky6.sum.more_15_5': 135,
		'lucky6.sum.more_26_5': 133,
		'lucky6.sum.more_38_5': 137,
		'poker.hands.hand_1': 301,
		'poker.hands.hand_2': 302,
		'poker.hands.hand_3': 303,
		'poker.hands.hand_4': 304,
		'poker.hands.hand_5': 305,
		'poker.hands.hand_6': 306,
		'poker.combinations.high_card': 321,
		'poker.combinations.one_pair': 322,
		'poker.combinations.two_pairs': 323,
		'poker.combinations.three_of_a_kind': 324,
		'poker.combinations.straight': 325,
		'poker.combinations.flush': 326,
		'poker.combinations.full_house': 327,
		'poker.combinations.four_of_a_kind': 328,
		'poker.combinations.straight_flush': 329,
		'poker.combinations.royal_flush': 330
	};
});

